'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/search/search'));
    processInclude(require('org/product/quickView'));
    processInclude(require('wishlists/product/wishlistHeart'));
    processInclude(require('./search/search'));
    processInclude(require('org/util/replaceImageOnErrorScript'));
});
